export default function Hero() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[680px] flex items-center bg-background-50 overflow-hidden pt-[68px]"
    >
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none"
        style={{
          backgroundImage: 'radial-gradient(circle at 1px 1px, currentColor 1px, transparent 1px)',
          backgroundSize: '24px 24px',
        }}
      ></div>

      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 max-w-7xl mx-auto">
          {/* Left: Text */}
          <div className="flex-1 w-full text-center lg:text-left">
            {/* Tag */}
            <span className="inline-block px-3 py-1 text-xs font-medium bg-primary-100 text-primary-700 rounded-full mb-4 whitespace-nowrap">
              每日更新 · 免费畅读
            </span>

            {/* H1 */}
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-950 leading-tight">
              韩漫网
              <br />
              <span className="text-primary-500">免费韩漫下拉式在线阅读平台</span>
            </h1>

            {/* Slogan */}
            <p className="mt-3 text-lg md:text-xl font-heading text-foreground-500">
              追更不等待，好漫画一卷到底
            </p>

            {/* Description */}
            <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0">
              韩漫网汇聚海量免费韩漫资源，涵盖恋爱、奇幻、悬疑、动作等多元题材。采用下拉式阅读模式，无需翻页等待，连续流畅沉浸体验。每日同步更新热门连载，确保追更零延迟，是韩漫爱好者的首选阅读家园。
            </p>

            {/* Stats */}
            <div className="mt-6 flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500">10,000+</div>
                <div className="text-xs text-foreground-500 mt-1">韩漫资源</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-500">每日更新</div>
                <div className="text-xs text-foreground-500 mt-1">同步连载</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500">下拉式</div>
                <div className="text-xs text-foreground-500 mt-1">流畅阅读</div>
              </div>
            </div>

            {/* CTAs */}
            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                className="inline-flex items-center gap-2 px-7 py-3 bg-primary-500 text-background-50 font-medium rounded-full text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                开始免费阅读
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href="#about"
                className="inline-flex items-center gap-2 px-7 py-3 border border-background-300 text-foreground-700 font-medium rounded-full text-sm hover:bg-background-100 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                了解平台
                <i className="ri-information-line"></i>
              </a>
            </div>
          </div>

          {/* Right: Visual */}
          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[480px] aspect-[4/3] rounded-xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=A%20stylized%20artistic%20illustration%20of%20Korean%20webtoon%20manhwa%20reading%20scene%2C%20featuring%20vibrant%20comic-style%20characters%20on%20a%20digital%20tablet%20screen%20with%20warm%20ambient%20glow%2C%20soft%20gradient%20background%20in%20coral%20and%20cream%20tones%2C%20modern%20flat%20illustration%20style%20with%20subtle%20texture%2C%20cozy%20reading%20atmosphere%2C%20editorial%20quality%20with%20clean%20composition%20and%20gentle%20shadows&width=960&height=720&seq=hero-visual-2026&orientation=landscape"
                alt="韩漫网 - 免费韩漫在线阅读平台主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent pointer-events-none"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}